import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PageResponse } from '@models/api';
import {
  GetUpdateDetailsResponse,
  getUpdateHistoryDetails,
  GetUpdateHistoryDetailsParams,
} from '@apis/esimBulk/update';

export const useUpdateDetails = ({
  page,
  pageSize,
  updateId,
  params,
}: {
  page: number;
  pageSize: number;
  updateId: number;
  params: GetUpdateHistoryDetailsParams;
}) => {
  const onlyFailed = Boolean(params?.onlyFailed);

  const queryOptions: UseQueryOptions<
    PageResponse<GetUpdateDetailsResponse>,
    Error
  > = {
    queryKey: ['updateHistoryDetails', updateId, page, pageSize, onlyFailed],
    queryFn: () => {
      return getUpdateHistoryDetails(updateId, {
        pageNo: page,
        pageSize: pageSize,
        ...(onlyFailed ? { onlyFailed: true } : {}),
      });
    },
    enabled: Number.isFinite(updateId) && updateId > 0,
  };
  return useQuery(queryOptions);
};
